import { render, staticRenderFns } from "./PatientPageManagement.vue?vue&type=template&id=0c818119&"
import script from "./PatientPageManagement.vue?vue&type=script&lang=js&"
export * from "./PatientPageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports